import script from "./RecuperarReservas.vue?vue&type=script&setup=true&lang=js"
export * from "./RecuperarReservas.vue?vue&type=script&setup=true&lang=js"

import "./RecuperarReservas.vue?vue&type=style&index=0&id=94872eee&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-94872eee"]])

export default __exports__